import * as React from 'react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface ProductTypeEditorViewProps  {
    value: number | null;
    mode: ControlMode;
    onChanged: (number: number | null) => void;
    label?: string;
    required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
	options?: any[];
}

export class ProductTypeEditorView extends React.Component<ProductTypeEditorViewProps, any> {
    public constructor(props) {
        super(props);
    }

    public render() {
        let label = this.props.label;
        if (label === undefined) {
            label = 'Product type';
        }
        return (
            <DropdownView
                label={label}
                onGetErrorMessage={this.props.onGetErrorMessage}
                onChanged={(item) => {
                    this.props.onChanged(item != null ? item.value : null);
                }}
                required={this.props.required}
                model={this.props.value}
                disabled={this.props.mode == 'display'}
                options={this.props.options != null?this.props.options:
                    [
                        { value: 0, label: 'General' },
                        { value: 1, label: 'Accomodation' },
                        { value: 2, label: 'Car Rent' },
                        { value: 3, label: 'Transfer' },
                        { value: 4, label: 'Flight' },
                        { value: 5, label: 'Room' },
						{ value: 6, label: 'Supplement/Discount' },
						{ value: 9, label: 'Tour' },
						{ value: 10, label: 'Package' },
                    ]
                }
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/products/products/parts/product-type-editor.view.tsx